
import { WorldCountry } from '../types';

export const australiaExpanded3: WorldCountry = {
  code: 'AU',
  name: 'Australia',
  slug: 'australia',
  population: 25739256,
  topCities: [
    // Ciudades principales existentes
    { name: 'Sydney', slug: 'sydney', population: 5312163 },
    { name: 'Melbourne', slug: 'melbourne', population: 5078193 },
    { name: 'Brisbane', slug: 'brisbane', population: 2560720 },
    { name: 'Perth', slug: 'perth', population: 2192229 },
    { name: 'Adelaide', slug: 'adelaide', population: 1402393 },
    { name: 'Gold Coast', slug: 'gold-coast', population: 679127 },
    { name: 'Newcastle', slug: 'newcastle', population: 322278 },
    { name: 'Canberra', slug: 'canberra', population: 460813 },
    { name: 'Central Coast', slug: 'central-coast', population: 333627 },
    { name: 'Wollongong', slug: 'wollongong', population: 305691 },
    
    // Nuevas ciudades - Expansión Fase 9
    { name: 'Geelong', slug: 'geelong', population: 280000 },
    { name: 'Hobart', slug: 'hobart', population: 240000 },
    { name: 'Townsville', slug: 'townsville', population: 220000 },
    { name: 'Cairns', slug: 'cairns', population: 200000 },
    { name: 'Darwin', slug: 'darwin', population: 180000 },
    { name: 'Toowoomba', slug: 'toowoomba', population: 170000 },
    { name: 'Ballarat', slug: 'ballarat', population: 160000 },
    { name: 'Bendigo', slug: 'bendigo', population: 150000 },
    { name: 'Albury', slug: 'albury', population: 140000 },
    { name: 'Launceston', slug: 'launceston', population: 130000 },
    { name: 'Mackay', slug: 'mackay', population: 120000 },
    { name: 'Rockhampton', slug: 'rockhampton', population: 110000 },
    { name: 'Bunbury', slug: 'bunbury', population: 100000 },
    { name: 'Bundaberg', slug: 'bundaberg', population: 95000 },
    { name: 'Coffs Harbour', slug: 'coffs-harbour', population: 90000 },
    { name: 'Wagga Wagga', slug: 'wagga-wagga', population: 85000 },
    { name: 'Hervey Bay', slug: 'hervey-bay', population: 80000 },
    { name: 'Mildura', slug: 'mildura', population: 75000 },
    { name: 'Shepparton', slug: 'shepparton', population: 70000 },
    { name: 'Port Macquarie', slug: 'port-macquarie', population: 68000 },
    { name: 'Gladstone', slug: 'gladstone', population: 66000 },
    { name: 'Tamworth', slug: 'tamworth', population: 64000 },
    { name: 'Dubbo', slug: 'dubbo', population: 62000 },
    { name: 'Orange', slug: 'orange', population: 60000 },
    { name: 'Geraldton', slug: 'geraldton', population: 58000 },
    { name: 'Nowra', slug: 'nowra', population: 56000 },
    { name: 'Warrnambool', slug: 'warrnambool', population: 54000 },
    { name: 'Kalgoorlie', slug: 'kalgoorlie', population: 52000 },
    { name: 'Lismore', slug: 'lismore', population: 50000 },
    { name: 'Alice Springs', slug: 'alice-springs', population: 48000 },
    { name: 'Devonport', slug: 'devonport', population: 46000 },
    { name: 'Goulburn', slug: 'goulburn', population: 44000 },
    { name: 'Bathurst', slug: 'bathurst', population: 42000 },
    { name: 'Warwick', slug: 'warwick', population: 40000 },
    { name: 'Armidale', slug: 'armidale', population: 38000 },
    { name: 'Mount Gambier', slug: 'mount-gambier', population: 36000 },
    { name: 'Broken Hill', slug: 'broken-hill', population: 34000 },
    { name: 'Muswellbrook', slug: 'muswellbrook', population: 32000 },
    { name: 'Singleton', slug: 'singleton', population: 30000 },
    { name: 'Cessnock', slug: 'cessnock', population: 28000 },
    { name: 'Maitland', slug: 'maitland', population: 26000 },
    { name: 'Lithgow', slug: 'lithgow', population: 24000 },
    { name: 'Grafton', slug: 'grafton', population: 22000 },
    { name: 'Moree', slug: 'moree', population: 20000 },
    { name: 'Inverell', slug: 'inverell', population: 19000 },
    { name: 'Glen Innes', slug: 'glen-innes', population: 18000 },
    { name: 'Tenterfield', slug: 'tenterfield', population: 17000 },
    { name: 'Casino', slug: 'casino', population: 16000 },
    { name: 'Kyogle', slug: 'kyogle', population: 15000 },
    { name: 'Murwillumbah', slug: 'murwillumbah', population: 14000 },
    { name: 'Byron Bay', slug: 'byron-bay', population: 13000 },
    { name: 'Ballina', slug: 'ballina', population: 12000 },
    { name: 'Tweed Heads', slug: 'tweed-heads', population: 11000 },
    { name: 'Nimbin', slug: 'nimbin', population: 10000 },
    { name: 'Mullumbimby', slug: 'mullumbimby', population: 9500 },
    { name: 'Bangalow', slug: 'bangalow', population: 9000 },
    { name: 'Clunes', slug: 'clunes', population: 8500 },
    { name: 'Maleny', slug: 'maleny', population: 8000 },
    { name: 'Montville', slug: 'montville', population: 7500 },
    { name: 'Mapleton', slug: 'mapleton', population: 7000 },
    { name: 'Nambour', slug: 'nambour', population: 6500 },
    { name: 'Palmwoods', slug: 'palmwoods', population: 6000 },
    { name: 'Woombye', slug: 'woombye', population: 5500 },
    { name: 'Yandina', slug: 'yandina', population: 5000 },
    { name: 'Eumundi', slug: 'eumundi', population: 4800 },
    { name: 'Cooroy', slug: 'cooroy', population: 4600 },
    { name: 'Pomona', slug: 'pomona', population: 4400 },
    { name: 'Kin Kin', slug: 'kin-kin', population: 4200 },
    { name: 'Boreen Point', slug: 'boreen-point', population: 4000 },
    { name: 'Tewantin', slug: 'tewantin', population: 3800 },
    { name: 'Noosaville', slug: 'noosaville', population: 3600 },
    { name: 'Noosa Heads', slug: 'noosa-heads', population: 3400 },
    { name: 'Peregian Beach', slug: 'peregian-beach', population: 3200 },
    { name: 'Coolum Beach', slug: 'coolum-beach', population: 3000 },
    { name: 'Marcoola', slug: 'marcoola', population: 2800 },
    { name: 'Mudjimba', slug: 'mudjimba', population: 2600 },
    { name: 'Diddillibah', slug: 'diddillibah', population: 2400 },
    { name: 'Kiels Mountain', slug: 'kiels-mountain', population: 2200 },
    { name: 'Kulangoor', slug: 'kulangoor', population: 2000 },
    { name: 'Bli Bli', slug: 'bli-bli', population: 1900 },
    { name: 'Maroochy River', slug: 'maroochy-river', population: 1800 },
    { name: 'Maroochydore', slug: 'maroochydore', population: 1700 },
    { name: 'Cotton Tree', slug: 'cotton-tree', population: 1600 },
    { name: 'Alexandra Headland', slug: 'alexandra-headland', population: 1500 },
    { name: 'Mooloolaba', slug: 'mooloolaba', population: 1400 },
    { name: 'Buderim', slug: 'buderim', population: 1300 },
    { name: 'Mountain Creek', slug: 'mountain-creek', population: 1200 },
    { name: 'Mooloolah Valley', slug: 'mooloolah-valley', population: 1100 },
    { name: 'Landsborough', slug: 'landsborough', population: 1000 },
    { name: 'Beerwah', slug: 'beerwah', population: 950 },
    { name: 'Glass House Mountains', slug: 'glass-house-mountains', population: 900 },
    { name: 'Beerburrum', slug: 'beerburrum', population: 850 },
    { name: 'Elimbah', slug: 'elimbah', population: 800 },
    { name: 'Wamuran', slug: 'wamuran', population: 750 },
    { name: 'Caboolture', slug: 'caboolture', population: 700 },
    { name: 'Morayfield', slug: 'morayfield', population: 650 },
    { name: 'Burpengary', slug: 'burpengary', population: 600 },
    { name: 'Narangba', slug: 'narangba', population: 550 },
    { name: 'Deception Bay', slug: 'deception-bay', population: 500 }
  ]
};
